<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="header-side"></div>
    <div class="dialog-title-text" cdkDragHandle>
        Recurring Loads (Stream ID: {{ streamId }})
    </div>
    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content style="margin-top: 10px;overflow-x: hidden;">
    <div style="text-align: end;margin-bottom: 10px;">
        @if(controlPermissions.addButton){
            <button  mat-raised-button color="primary" mat-primary (click)="onAddRecurLoad()" >
                <mat-icon>add</mat-icon>
                Add Recurr Load
            </button>
        }
    </div>

    <!-- Angular Material Table -->
    <div  class="gridheight mat-elevation-z8 viewport">
        <table mat-table [dataSource]="dataSource"  multiTemplateDataRows matSort>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let row">
                    <div>
                        <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="onEditRecurLoad(row, 'Edit')">
                            <mat-icon>edit</mat-icon>
                        </button>
                        @if(controlPermissions.delete){
                            <button mat-icon-button type="button" color="warn" title="Delete" (click)="onDeleteRecurLoad(row.id, row.recur_typeName)" style="color: red;">
                                <mat-icon>delete</mat-icon>
                            </button>
                        }
                    </div>
                </td>
            </ng-container>

            <!-- Data Columns -->
            <ng-container matColumnDef="weekDays">
                <th mat-header-cell *matHeaderCellDef class="font-bold bg-gray-100">Week Days</th>
                <td mat-cell *matCellDef="let element"> {{element.weekDays}} </td>
            </ng-container>

            <ng-container matColumnDef="disposalSiteNames">
                <th mat-header-cell *matHeaderCellDef class="font-bold bg-gray-100">Disposal Site</th>
                <td mat-cell *matCellDef="let element"> {{element.disposalSiteNames}} </td>
            </ng-container>
            
            <ng-container matColumnDef="tankName">
                <th mat-header-cell *matHeaderCellDef class="font-bold bg-gray-100">Tank</th>
                <td mat-cell *matCellDef="let element"> {{element.tankName}} </td>
            </ng-container>

            <ng-container matColumnDef="recur_typeName">
                <th mat-header-cell *matHeaderCellDef class="font-bold bg-gray-100">Recur Type</th>
                <td mat-cell *matCellDef="let element"> {{element.recur_typeName}} </td>
            </ng-container>
            
            <ng-container matColumnDef="daySequenceName">
                <th mat-header-cell *matHeaderCellDef class="font-bold bg-gray-100">Day Sequence</th>
                <td mat-cell *matCellDef="let element"> {{element.daySequenceName}} </td>
            </ng-container>

            <ng-container matColumnDef="noOfRecurrings">
                <th mat-header-cell *matHeaderCellDef class="font-bold bg-gray-100">No of Loads</th>
                <td mat-cell *matCellDef="let element"> {{element.noOfRecurrings}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            
            <!-- No Data Row -->
            <tr class="mat-row hover:bg-transparent" *matNoDataRow>
                <td class="mat-cell text-center text-gray-500 py-4" [attr.colspan]="displayedColumns.length">
                    No recurring loads found for this stream.
                </td>
            </tr>
        </table>
    </div>
</mat-dialog-content>

<!-- Footer for closing the dialog -->
<mat-dialog-actions align="end" class="dialog-footer">
    <button (click)="close()" mat-raised-button color="primary" mat-primary>
        Close
    </button>
</mat-dialog-actions>